//
import UserModel from '@/models/General/GUser'
import ProviderModel from '@/models/Purchase/PchProvider'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'

//
export default [
    {
        name: "pch_provider_id",
        props: {
            itemText: "rut",
            itemValue: "id",
            label: "Rut",
            model: ProviderModel,
            noObject: true,
            paramSearch: "search",
        },
        type: "autocomplete-model",
    },
    {
        name: 'pch_provider_id',
        props: {
            chips: true,
            itemText: 'alias_name',
            itemValue: 'id',
            label: 'Proveedor',
            model: ProviderModel,
            noObject: true,
        },
        type: 'autocomplete-model',
    },
    {
        name: 'g_originator_user_id',
        props: {
            chips: true,
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noObject: true,
        },
        type: 'autocomplete-model',
    },
    {
        name: 'g_authorizer_user_id',
        props: {
            chips: true,
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Supervisor',
            model: UserModel,
            noObject: true,
        },
        type: 'autocomplete-model',
    },
    {
        name: 'wh_warehouse_id',
        props: {
            chips: true,
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            noObject: true,
        },
        type: 'autocomplete-model',
    },
    {
        name: 'invoice_number',
        props: {
            label: 'Factura',
        },
        type: 'text-field',
    },
]
